import { render, staticRenderFns } from "./redirectMenu.vue?vue&type=template&id=0d484b79&scoped=true&"
import script from "./redirectMenu.vue?vue&type=script&lang=js&"
export * from "./redirectMenu.vue?vue&type=script&lang=js&"
import style0 from "./redirectMenu.vue?vue&type=style&index=0&id=0d484b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d484b79",
  null
  
)

export default component.exports